import React from "react";
import axios from "axios";
import "./styles.css";
import { formatDate } from "../../lib/helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReceipt } from "@fortawesome/free-solid-svg-icons";

const InventoryTable = ({ items, addToCart }) => {
  const handleDownloadReceipt = async (receiverId) => {
    //split the receiverId to get the id by comma
    const id = receiverId.split(",")[0];
    console.log("Receiver ID:", id);

    try {
      const token = localStorage.getItem("authToken");
      const endpoint = `${process.env.REACT_APP_ROOT_URL}/api/customer/download-receipt/${id}`;
      console.log("Requesting receipt from:", endpoint);

      const response = await axios.get(endpoint, {
        responseType: "blob", // Important for handling binary data
        headers: {
          Authorization: `Bearer ${token}`,
        },
        // Uncomment the following line if your API needs credentials (cookies, etc.)
        // withCredentials: true,
      });

      console.log("Received response:", response);

      // Create a Blob from the response data and a download URL from that Blob
      const blob = new Blob([response.data], { type: "application/pdf" });
      const downloadUrl = window.URL.createObjectURL(blob);

      // Create a temporary link element and trigger a click to download the file
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `receipt-${receiverId}.pdf`;
      document.body.appendChild(link);
      link.click();

      // Clean up the DOM and URL object
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Error downloading receipt:", error);

      // Additional logging to help pinpoint the issue
      if (error.response) {
        // The request was made and the server responded with a status code outside 2xx
        console.error("Server responded with status:", error.response.status);
        console.error("Response data:", error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        console.error("No response received. Request details:", error.request);
      } else {
        // Something else happened while setting up the request
        console.error("Error message:", error.message);
      }
    }
  };

  return (
    <div className="catalog-table">
      {items ? (
        <table className="table table-striped table-inventory">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Description</th>
              <th scope="col">ITEM #</th>
              <th scope="col">Reference #</th>
              <th scope="col">PO #</th>
              <th scope="col">Received</th>
              <th scope="col">Avail.</th>
              <th scope="col">Received Date</th>
              <th scope="col">Internal Ref ID</th>
              <th scope="col">Action</th>
              <th scope="col">View Receipt</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => {
              return (
                <tr
                  key={item.receiveItemId}
                  style={{ verticalAlign: "middle" }}
                >
                  <td style={{ verticalAlign: "middle" }}>
                    {item.description}
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    {item.itemIdentifier.sku}
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    {item.referenceNum}
                  </td>
                  <td style={{ verticalAlign: "middle" }}>{item.poNum}</td>
                  <td style={{ verticalAlign: "middle" }}>{item.received}</td>
                  <td style={{ verticalAlign: "middle" }}>{item.available}</td>
                  <td style={{ verticalAlign: "middle" }}>
                    {formatDate(item.receivedDate)}
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    {item.receiveItemId}
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => addToCart(item)}
                    >
                      Add to Cart
                    </button>
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={() => handleDownloadReceipt(item.receiveItemId)}
                    >
                      <FontAwesomeIcon icon={faReceipt} /> Receipt
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        "No results found."
      )}
    </div>
  );
};

export default InventoryTable;
